<template>
  <div class="category-selection">
    <img
      v-if="assetType(configs.categoryBackground) === 'image'"
      class="category-selection__background"
      :src="`${$store.state.assetsPath}${configs.categoryBackground}`"
    >
    <video
      v-if="assetType(configs.categoryBackground) === 'video'"
      class="category-selection__background"
      :src="`${$store.state.assetsPath}${configs.categoryBackground}`"
      autoplay
      muted
      loop 
    ></video>
    <div class="category-selection__container">
      <div class="category-selection__map">
        <img src="/assets/region-centred-map.png" alt="">
      </div>
      <div class="category-selection__welcome">
        <h1 class="welcome-text">Explore the regions of South Australia</h1>
      </div>
      <div class="category-selection__categories">
        <div
          v-for="category in categories"
          class="category-selection__category touch"
          :key="category._id"
          @click="navigateToCategory(category)"
        >
          <div class="category-selection__category-inner">
            <div v-if="category.buttonBackground" class="category-selection__bg">
              <img :src="`${$store.state.assetsPath}${category.buttonBackground.asset.path}`">
            </div>
            <div class="category-selection__label" v-html="category.label[language.code]"></div>
          </div>
        </div>
      </div>
      <div class="category-selection__touch-prompt">
        <img src="/assets/touch-prompt.png">
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash'
import { mapActions } from 'vuex'
export default {
  computed: {
    categories () {
      return this.$store.getters.navigation
    },

    configs () {
      const categoryBackground = this.$store.state.config.categoryBackground

      return {
        categoryBackground,
      }
    },

    language () {
      return this.$store.getters.language
    },
    
    pages () {
      return this.$store.state.pages
    }
  },

  mounted () {
    this.$store.commit('RESET_ANIMATION_DATA')
  },

  methods: {
    ...mapActions([
      'activateCategoryById'
    ]),

    assetType (path) {
      if (path.split('.').pop() === 'mp4') {
        return 'video'
      }

      return 'image'
    },

    navigateToCategory(category) {
      if (category.customRoute) {
        this.$router.push(category.customRoute)
      } else {
        const defaultChild = _.find(this.pages, page => {
          return page._id === category.defaultChildId
        })

        if (defaultChild) {
          this.$router.push(`/category/${category._id}/page/${defaultChild._id}`)
        } else {
          this.$router.push(`/category/${category._id}/page/${category.children[0].pageId}`)
        }
      }
    }
  }
}
</script>
<style lang="scss">
@import "@/styles/_variables.scss";

.category-selection {
  align-items: flex-end;
  background-position: 50%;
  background-size: cover;
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;

  &__background {
    height: 100%;
    left: 0;
    object-fit: cover;
    position: absolute;
    top: 0;
    width: 100%;
  }

  &__container {
    background: rgba($black, 0);
    display: flex;
    flex-direction: column;
    margin: 0 0 6rem;
    padding: 0;
    width: 145.5rem;
  }

  &__categories {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    grid-template-rows: repeat(2, 1fr);
    grid-column-gap: 2rem;
    grid-row-gap: 2rem;
    height: 20.1rem;
  }

  &__welcome {
    display: flex;
    flex-direction: column;
    justify-content: center;

    .welcome-text {
      font-size: 3.2rem;
      font-weight: 700;
      letter-spacing: .5rem;
      margin: 1em;
      opacity: .6;
      text-align: center;
      text-transform: uppercase;
    }
  }

  &__category {
    background: #000;
    border-radius: .5rem;
    box-shadow: $tag-box-shadow;
    overflow: hidden;
    width: 22.5rem;
  }

  &__category-inner {
    align-items: center;
    display: flex;
    font-size: 1.3rem;
    font-weight: 400;
    height: 100%;
    justify-content: center;
    letter-spacing: .2rem;
    position: relative;
    text-align: center;
    text-transform: uppercase;
    width: 100%;
  }

  &__bg {
    height: 100%;
    opacity: .8;
    position: absolute;
    width: 100%;

    img {
      height: 100%;
      object-fit: cover;
      width: 100%;
    }
  }

  &__label {
    text-shadow: 0 0px 5px rgba(0, 0, 0, 0.5);
    z-index: 10;
  }

  &__map {
    display: flex;
    justify-content: center;
    height: 44rem;
    margin: 0 0 5rem;
    z-index: 1;

    img {
      height: 100%;
      object-fit: contain;
      width: 100%;
    }
  }

  &__touch-prompt {
    display: flex;
    justify-content: center;
    margin-top: 3rem;

    img {
      animation: pulse 4s ease-in-out .6s infinite;
      height: 8.5rem;
    }
  }
}
</style>